module.exports = __webpack_public_path__ + "static/media/s_v10_33.903170cb.mp3";